import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Tag } from 'primereact/tag';

type Transaction = {
    id: string;
    name: string;
    amount: number;
    time: string;
    status: 'Completed' | 'Pending' | 'Failed';
};

const transactions: Transaction[] = [
    { id: '1', name: 'Md. Rahim', amount: 3500, time: '08:30 AM', status: 'Completed' },         // Rental payment
    { id: '2', name: 'CNG Fuel Station', amount: -700, time: '09:10 AM', status: 'Completed' },  // Fuel expense
    { id: '3', name: 'Shah Alam', amount: 4200, time: '10:45 AM', status: 'Pending' },           // Rental payment
    { id: '4', name: 'Parking Fee (Gulshan)', amount: -300, time: '11:20 AM', status: 'Completed' }, // Parking expense
    { id: '5', name: 'Refund - Jannat Ara', amount: -1500, time: '12:05 PM', status: 'Failed' }, // Failed refund
];

const amountBodyTemplate = (rowData: Transaction) => (
    <span
        style={{
            color: rowData.amount >= 0 ? '#22c55e' : '#ef4444',
            display: 'flex',
            alignItems: 'center',
            gap: 4,
        }}
    >
        <i
            className={`pi ${rowData.amount >= 0 ? 'pi-arrow-up' : 'pi-arrow-down'}`}
            style={{ fontSize: '1rem' }}
        ></i>
        {Math.abs(rowData.amount)}
    </span>
);

const statusBodyTemplate = (rowData: Transaction) => {
    let severity: 'success' | 'warning' | 'danger' = 'success';
    if (rowData.status === 'Pending') severity = 'warning';
    else if (rowData.status === 'Failed') severity = 'danger';
    return <Tag value={rowData.status} severity={severity} />;
};

const Transactions: React.FC = () => (
    <DataTable
        className="pt-2"
        value={transactions}
        paginator
        rows={5}
        stripedRows
    >
        <Column field="name" header="Name" />
        <Column header="Amount" body={amountBodyTemplate} />
        <Column field="time" header="Time" />
        <Column header="Status" body={statusBodyTemplate} />
    </DataTable>
);

export default Transactions;
